export enum BreadOrderStatus {
    PENDING = 'pending',
    BAKED = 'baked',
    COMPLETED = 'completed',
}

export class BreadOrder {
    id: string;
    date: string;
    time: string;
    firstName: string;
    lastName: string;
    phoneNumber: string;
    bread: Array<Bread>;
    comments: string;
    cashier: string;
    createdAt: Date;
    status: BreadOrderStatus;
    store_id: string;
    customerId: string | null;

    constructor(
       { id, date, time, firstName, lastName, phoneNumber,
        bread, comments, cashier, createdAt, status, store_id, customerId = null }
    ) {
        if (!status) status = BreadOrderStatus.PENDING;

        this.id = id;
        this.date = date;
        this.time = time;
        this.firstName = firstName;
        this.lastName = lastName;
        this.phoneNumber = phoneNumber;
        this.bread = bread;
        this.comments = comments;
        this.cashier = cashier;
        this.createdAt = createdAt;
        this.status = status;
        this.store_id = store_id;
        this.customerId = customerId;
    }

    toJson() {
        return {
            id: this.id,
            date: this.date,
            time: this.time,
            firstName: this.firstName,
            lastName: this.lastName,
            phoneNumber: this.phoneNumber,
            bread: JSON.stringify(this.bread),
            comments: this.comments,
            cashier: this.cashier,
            createdAt: this.createdAt.toString(),
            status: this.status,
            store_id: this.store_id,
            customerId: this.customerId || null,
        };
    }

    getBreads() {
        return this.bread.map((b) => `${b.quantity} ${b.bread}`).join(', ');
    }

    static fromFirebase(doc) {
        const data = doc.data();
        console.log("Bread", data.bread);
        return new BreadOrder(
            {
            id: doc.id,
            date: data.date,
            time: data.time,
            firstName: data.firstName,
            lastName: data.lastName,
            phoneNumber: data.phoneNumber,
            bread: JSON.parse(data.bread),
            comments: data.comments,
            cashier: data.cashier,
            createdAt: data.createdAt,
            status: data.status,
            store_id: data.store_id || '',
            customerId: data.customerId || null
            }
        );

    }

    getFormattedDate() {
        const dateParts = this.date.split('T')[0].split('-'); // ['2025', '05', '09']
        const localDate = new Date(Number(dateParts[0]), Number(dateParts[1]) - 1, Number(dateParts[2]));
        const options: Intl.DateTimeFormatOptions = { weekday: 'long', month: 'long', day: 'numeric' };
        return localDate.toLocaleDateString('es-MX', options);
    }
}

export interface Bread {
  bread: string;
  quantity: number;
}

//enum for statuses
